<template>
  <v-dialog v-model="dialog" width="400px" scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        <v-toolbar-title>SỬA BỘ MÔN</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-form ref="form">
          <v-text-field
            outlined
            dense
            v-model="title"
            class="required mt-4"
            :rules="[$rules.required]"
            label="Tên ban"
          />
          <CheckboxAcademicLevel :defaults="academicLevels" @change="academicLevels = $event" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row class="pa-2" no-gutters>
          <v-btn class="px-4" outlined light depressed @click="cancel">Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="px-6" dark depressed color="#0D47A1" :loading="loading" @click="save">Lưu</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CheckboxAcademicLevel from '@/modules/academicLevel/CheckboxAcademicLevel.vue'

export default {
  components: {
    CheckboxAcademicLevel
  },
  props: {
    state: Boolean,
    subjectGroup: { type: Object, default: () => {} }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      title: '',
      academicLevels: []
    }
  },
  created() {
    if (this.subjectGroup) {
      this.title = this.subjectGroup.title
      this.academicLevels = this.subjectGroup.academicLevels
    }
  },
  computed: {
    ...mapState('SubjectGroup', ['subjectGroups'])
  },
  methods: {
    ...mapActions('SubjectGroup', ['updateSubjectGroup']),
    async save() {
      if (!this.$refs.form.validate()) return
      if (this.academicLevels && this.academicLevels.length === 0) {
        this.$alert.error('Chưa chọn cấp học')
        return
      }
      try {
        this.loading = true
        await this.updateSubjectGroup({
          id: this.subjectGroup.id,
          title: this.title,
          academicLevels: this.academicLevels
        })
        this.$alert.updateSuccess()
        this.dialog = false
      } catch (error) {
        this.$alert.updateError()
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    resetValidation() {
      this.$refs.form && this.$refs.form.resetValidation()
    },
    cancel() {
      this.dialog = false
      // this.reset()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    subjectGroup: {
      handler(val) {
        if (val) {
          this.title = val.title
          this.academicLevels = val.academicLevels
        }
      },
      deep: true
    }
  }
}
</script>
